export enum EstadoValidacionDteRecibido {
   "No validada" = 1,
   "Pre-aprobada",
   "Pre-rechazada",
   "Aceptada",
   "Rechazada",
}
